import styled from 'styled-components';
import {
  Box, IBoxProps, Flex, Text, Headline,
  Heading as SliceHeading,
  Image as SliceImage,
  Script as LceScript,
  mediaQueries
} from '@lce/slice';

import { SafeImage } from '../../ui/SafeImage';

interface IImageProps extends IBoxProps {
  imageFirst: boolean;
}

export const PromoBanner = styled(Box)`
  background-color: ${props => props.theme.colors.orange};
`;

export const FlexContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQueries[1]} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const ImageWrapper = styled(Box)<IImageProps>`
  flex: 2 0 auto;
  align-self: flex-start;
  justify-self: flex-end;
  margin: 0 auto;

  ${mediaQueries[1]} {
    order: ${ props => (props.imageFirst ? 'initial' : '1') };
    margin-bottom: 0;
  }
`;

export const Image = styled(SafeImage)`
  vertical-align: bottom;
`;

export const Legal = styled(Text)`
  padding: 0 0 8px 0;
  font-size: 0.75rem;
  line-height: 1.08;
  text-align: right;
`;

export const TextBox = styled(Box)`
  text-align: center;
`;

export const Subheading = styled(SliceHeading)`
  font-size: 36px;
  line-height: 32px;

  ${mediaQueries[0]} {
    font-size: 36px;
  }

  ${mediaQueries[1]} {
    font-size: 36px;
  }

  ${mediaQueries[2]} {
    font-size: 36px;
  }
`;

export const Heading = styled(Headline)`
  color: ${props => props.theme.colors.white};
  font-size: 64px;
  max-width: 320px;
  margin: 0 auto;

  ${mediaQueries[0]} {
    max-width: inherit;
    margin-bottom: 0;
    font-size: 64px;
  }

  ${mediaQueries[1]} {
    font-size: 74px;
  }

  ${mediaQueries[2]} {
    font-size: 74px;
  }
`;

export const Sup = styled.sup`
  font-size: 28px;
  line-height: 1;
`;

export const Promo = styled(Headline)`
  color: ${props => props.theme.colors.white};
  max-width: 256px;
  line-height: 0.2em;

  ${mediaQueries[0]} {
    max-width: inherit;
  }
`;

export const LeftSprites = styled(SliceImage)`
  margin-right: 10px;
  height: 40px;
`;

export const RightSprites = styled(SliceImage)`
  transform: rotate(180deg);
  height: 40px;
  margin-left: 10px;
`;

export const Details = styled(Text)`
  font-family: ${props => props.theme.fonts.mrEaves};
  font-size: 24px;
`;

export const PromoInstructions = styled(Text)`
  font-family: ${props => props.theme.fonts.mrEaves};
  font-weight: bold;
  text-transform: uppercase;
`;

export const Script = styled(LceScript)`
  max-width: 320px;

  ${mediaQueries[0]} {
    max-width: inherit;
  }
`;
